import {SettingParamTypes, FlowNodeData, FlowNodeTypes} from "@/types/node";
import {Node} from "@xyflow/react";

export const jumpNodeBlueprint: Partial<Node<FlowNodeData>> = {
  type: FlowNodeTypes.JUMP,
  data: {
    type: FlowNodeTypes.JUMP,
    settingsTitle: "Jump To",
    description: "This is the jump node",
    onChange: () => {
      console.log("Start node changed");
    },
    isEmpty: true,
    settings: [
      {
        title: "Jump To Settings",
        description: "",
        params: [
          {
            label: "Choose which node the conversation should move to.",
            type: SettingParamTypes.NODE_SELECT,
            key: "jump_to_step",
            value: "",
            placeholder: "Select",
          },
        ],
      },
    ],
  },
  position: {x: 0, y: 0},
};
